import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-finish-pap',
  templateUrl: './finish-pap.component.html',
  styleUrls: ['./finish-pap.component.css']
})
export class FinishPapComponent implements OnInit {

  pap:any;

  constructor(
              private title: Title,
              private _securityService: SecurityService,
              private _loaderService: LoaderService
    ) {
      this.title.setTitle('Onboarding Digital | Finalizar');
    }

  async ngOnInit() {
      this._securityService.showPapData()
        .subscribe({
          next: async (response: any) => {
            this._loaderService.hide();
            this.pap = response?.data;
          },
          error: async (error: any) => {
            this._loaderService.hide()
            console.error("ERROR: ", error);
          }
        });
  }

  formatQuota(quota: number): string {
    return quota.toLocaleString('es-CO');
  }
    
  finish() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = 'https://www.fincomercio.com';
  }
}
